import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const bDCategoriesApi = createApi({
  reducerPath: 'bDCategoriesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Blocking-Domains-Category'],
  endpoints: (builder) => ({
    getBlockingDomainCategories: builder.query({
      query: (params) => ({
        url: `/blocking_domain/categories/`,
        params,
      }),
      providesTags: ['Blocking-Domains-Category'],
    }),

    createBlockingDomainCategory: builder.mutation({
      query: (body) => ({
        url: '/blocking_domain/categories/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Blocking-Domains-Category'],
    }),

    getBlockingDomainCategoryById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/blocking_domain/categories/${id}/`,
        params,
      }),
      providesTags: (result, error, { id }) => [{ type: 'Blocking-Domains-Category', id }],
    }),

    updateBlockingDomainCategoryById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/blocking_domain/categories/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Blocking-Domains-Category'],
    }),
    

    deleteBlockingDomainCategoryById: builder.mutation({
      query: (id) => ({
        url: `/blocking_domain/categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Blocking-Domains-Category'],
    }),

    
  }),
});

export const {
  useGetBlockingDomainCategoriesQuery,
  useLazyGetBlockingDomainCategoriesQuery,
  useCreateBlockingDomainCategoryMutation,
  useGetBlockingDomainCategoryByIdQuery,
  useUpdateBlockingDomainCategoryByIdMutation,
  useDeleteBlockingDomainCategoryByIdMutation,
} = bDCategoriesApi;
